<template>
  <div class="banner">
    <div class="content-center">
      <div class="banner-body">
        <div class="banner-title">易隆创·服务生态</div>
        <div class="banner-subtitle">全链路的服务，打破服务的区域限制</div>
        <div class="primary-btn" @click="setWorkOrderPopup(true)">现在下单</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  methods: {
    ...mapActions(['setWorkOrderPopup']),
  }
};
</script>

<style lang="less" scoped>
.banner {
  height: 460px;
  background-image: url('@/assets/img/service/Banner/background.png');
  background-size: cover;
  background-position: center;

  .content-center {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .banner-body {
      .banner-title {
        font-family: @font-bold;
        color: #fff;
        font-size: 32px;
        line-height: 65px;
        letter-spacing: 2px;
      }
      .banner-subtitle {
        margin-top: 13px;
        color: #fff;
      }
      .primary-btn {
        width: 164px;
        margin-top: 53px;
      }
    }
  }
}
</style>
